<div class="event">
  <div class="data">
    <div class="info">
      <div class="timetrange">
        {{ vm.timeFormatFunction(event.startsAtMs) }} -
        {{ vm.timeFormatFunction(event.endsAtMs) }}
      </div>
      <div
        [class]="{
          title: true,
          approved: event.isApproved || event.isMitigated
        }"
      >
        <span> {{ event.title }} </span>
      </div>
      <div class="action">
        <div class="action-decription">
          {{
            event.isApproved
              ? "Approved"
              : event.isMitigated
                ? "Mitigated"
                : "Detected"
          }}
        </div>
        <div class="action-undo" (click)="revertEvent($event)">
          <svg
            width="11"
            height="11"
            viewBox="0 0 11 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M3.61886 2.18749C3.47791 2.04655 3.24944 2.04655 3.10849 2.18749L1.66488 3.6311C1.52394 3.77204 1.52394 4.00056 1.66488 4.1415L3.10849 5.58509C3.24944 5.72604 3.47791 5.72604 3.61886 5.58509C3.7598 5.44415 3.7598 5.21565 3.61886 5.07471L2.79138 4.2472H7.2133C8.34278 4.2472 9.25842 5.16283 9.25842 6.29232C9.25842 7.4218 8.34279 8.33743 7.2133 8.33743H3.84488C3.64556 8.33743 3.48397 8.49902 3.48397 8.69834C3.48397 8.89765 3.64556 9.05924 3.84488 9.05924H7.2133C8.74143 9.05924 9.98022 7.82043 9.98022 6.29232C9.98022 4.76419 8.74143 3.5254 7.2133 3.5254H2.79138L3.61886 2.69789C3.7598 2.55695 3.7598 2.32843 3.61886 2.18749Z"
              fill="black"
              fill-opacity="0.6"
            />
          </svg>
        </div>
      </div>
    </div>
  </div>
  <div class="frames">
    <img
      [src]="process(event.startFrame) || '/assets/ccstudio/loading.svg'"
    /><img [src]="process(event.endFrame) || '/assets/ccstudio/loading.svg'" />
  </div>
</div>
